<template>
  <!-- loader Start -->
  <div id="loading" :style="style">
    <div id="loading-center">
    </div>
  </div>
  <!-- loader END -->
</template>
<script>
import { socialvue } from '@/config/pluginInit'
export default {
  name: 'Loader',
  props: {
    dark: { type: Boolean, default: false }
  },
  computed: {
    applicationStaticConfig () {
      return { ...this.$store.getters["AppicationStaticConfig/getApplicationStaticConfig"] }
    }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      style: ""
    }
  },
  methods: {
    init () {
      socialvue.loaderInit()
      this.style = `background: #fff url(${this.applicationStaticConfig.app_logo}) no-repeat scroll center center;background-size:10%;`
    }
  }
}
</script>
